import { render } from "./Model3DPaperMaking.vue?vue&type=template&id=592735a6&scoped=true"
import script from "./Model3DPaperMaking.vue?vue&type=script&lang=js"
export * from "./Model3DPaperMaking.vue?vue&type=script&lang=js"

import "./Model3DPaperMaking.vue?vue&type=style&index=0&id=592735a6&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592735a6"]])

export default __exports__